module.exports = __webpack_public_path__ + "img/icon_theme_red.69bafa29.svg";